import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { CardElement, Elements, ElementsConsumer } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

import { client } from 'cogsworth/utils/ApolloClient'
import Loading from 'cogsworth/components/Loading/Loading'
import { CURRENCIES } from 'cogsworth/constants'

import createAppointmentStripePaymentIntent from 'graphql/mutations/createAppointmentStripePaymentIntent'

import './bookingPayment.css'

class StripeForm extends Component {
  static propTypes = {
    businessId: PropTypes.string.isRequired,
    stripeAccount: PropTypes.object.isRequired,
    amount: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    onPaymentComplete: PropTypes.func.isRequired,
    description: PropTypes.string.isRequired,

    stripe: PropTypes.object,
    elements: PropTypes.object,
  }

  constructor(props) {
    super(props)

    this.state = {
      error: null,
      saving: false,
    }

    this.onCCFormChanged = this.onCCFormChanged.bind(this)
  }

  componentDidMount() {
    this.createPaymentIntent()
  }

  async createPaymentIntent() {
    try {
      const { data: { createAppointmentStripePaymentIntent: { paymentIntent } } } = await client.mutate({
        mutation: createAppointmentStripePaymentIntent,
        variables: {
          appointmentId: this.props.appointmentId,
        },
      })

      this.setState({
        paymentIntent,
      })
    } catch (error) {
      const graphqlError = error.graphQLErrors ? error.graphQLErrors[0] : {}
      if (graphqlError.message === 'APPOINTMENT_NOT_FOUND') {
        this.props.dispatch({ type: 'RESET' })
        return
      }
      this.setState({
        paymentIntentError: error.message
      })
    }

  }

  async onSubmit(e) {
    this.setState({ error: null, saving: true })

    const { elements, stripe } = this.props
    const { paymentIntent } = this.state

    e.preventDefault()

    console.log('paying', paymentIntent)

    const cardElement = elements.getElement(CardElement)
    const result = await stripe.confirmCardPayment(paymentIntent.client_secret, {
      payment_method: {
        card: cardElement,
        billing_details: {
          name: this.props.customerName,
        },
      }
    })

    if (result && result.error) {
      this.setState({ error: result.error, saving: false })
      return
    }

    console.log('confirmCardPayment', result)
    this.props.onPaymentComplete(result, 'stripe')

    this.setState({ saving: false })

    return false
  }

  onCCFormChanged() {
    this.setState({ error: null })
  }

  render() {
    const { stripe } = this.props
    const { paymentIntent, paymentIntentError } = this.state

    // We need stripe to be available
    if (stripe === undefined) {
      return null
    }

    if (paymentIntentError) {
      return (
        <div className="stripe-pi-error">
          <strong>Stripe Payment unavailable:</strong>
          { paymentIntentError.replace('GraphQL error: ', '') }<br />
          Please contact administrator to book a meeting
        </div>
      )
    }

    if (paymentIntent === undefined) {
      return <Loading relative />
    }

    const currencyExponent = CURRENCIES[paymentIntent.currency.toUpperCase()].exponent
    const amountWithDecimals = paymentIntent.amount / Math.pow(10, currencyExponent)

    return (
      <div id="stripe-form">
        <small>Enter your card details below to process payment securely with Stripe.</small>
        <form onSubmit={this.onSubmit.bind(this)}>
          <div className="cc-form">
            { this.state.error && <span className="error">{ this.state.error.message }</span> }
            <CardElement onChange={this.onCCFormChanged} />
          </div>
          <button type="submit" className="btn btn-primary" disabled={this.state.saving}>
            { !this.state.saving && <span>Pay {paymentIntent.currency.toUpperCase()} {(amountWithDecimals).toFixed(currencyExponent)}</span> }
            { this.state.saving && <i className="fa fa-gear fa-spin" /> }
          </button>
        </form>
      </div>
    )
  }
}

class StripeConnectLoader extends Component {
  render() {
    const { stripeAccount } = this.props

    if (!stripeAccount) {
      return null
    }

    const stripe = loadStripe(stripeAccount.stripePublishableKey, { stripeAccount: stripeAccount.stripeAccountId })

    return <Elements stripe={stripe}>
      <ElementsConsumer>
        {({elements, stripe}) => (
          <StripeForm elements={elements} stripe={stripe} {...this.props}/>
        )}
      </ElementsConsumer>
    </Elements>
  }
}

const mapStateToProps = (state) => ({
  coupon: state.coupon,
})

export default connect(mapStateToProps)(StripeConnectLoader)
